var map = {
	"./Agency/Blogs/Create.vue": [
		"./src/components/Agency/Blogs/Create.vue",
		"src_store_modules_MCOptions_js",
		"src_store_modules_MCOptions2_js",
		"src_components_Agency_Blogs_Create_vue"
	],
	"./Agency/Blogs/Design.vue": [
		"./src/components/Agency/Blogs/Design.vue",
		"src_components_Agency_Blogs_Design_vue"
	],
	"./Agency/Blogs/Edit.vue": [
		"./src/components/Agency/Blogs/Edit.vue",
		"src_components_Agency_Blogs_Edit_vue"
	],
	"./Agency/Blogs/Form.vue": [
		"./src/components/Agency/Blogs/Form.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Blogs_Form_vue"
	],
	"./Agency/Blogs/Index.vue": [
		"./src/components/Agency/Blogs/Index.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Blogs_Index_vue"
	],
	"./Agency/Blogs/Share.vue": [
		"./src/components/Agency/Blogs/Share.vue",
		"src_components_Agency_Blogs_Share_vue"
	],
	"./Agency/Card/Transfer.vue": [
		"./src/components/Agency/Card/Transfer.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Card_Transfer_vue"
	],
	"./Agency/Pages/AgentaiDesignWrap.vue": [
		"./src/components/Agency/Pages/AgentaiDesignWrap.vue",
		"src_components_Agency_Pages_AgentaiDesignWrap_vue"
	],
	"./Agency/Pages/Blocks2/Index.vue": [
		"./src/components/Agency/Pages/Blocks2/Index.vue",
		"src_components_Agency_Pages_Blocks2_Index_vue"
	],
	"./Agency/Pages/BuildStepFull.vue": [
		"./src/components/Agency/Pages/BuildStepFull.vue",
		"src_components_Agency_Websites_Styles_DesignBox_scss-src_components_Agency_Websites_Styles_Pr-7b908d",
		"src_components_Agency_Pages_BuildStepFull_vue"
	],
	"./Agency/Pages/BuildStepFull2.vue": [
		"./src/components/Agency/Pages/BuildStepFull2.vue",
		"src_components_Agency_Websites_Styles_DesignBox_scss-src_components_Agency_Websites_Styles_Pr-7b908d",
		"src_components_Agency_Pages_BuildStepFull2_vue"
	],
	"./Agency/Pages/Cards/Backup.vue": [
		"./src/components/Agency/Pages/Cards/Backup.vue",
		"src_components_Agency_Pages_Cards_Backup_vue"
	],
	"./Agency/Pages/Cards/Blog.vue": [
		"./src/components/Agency/Pages/Cards/Blog.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Pages_Cards_Blog_vue"
	],
	"./Agency/Pages/Cards/BusinessInformation.vue": [
		"./src/components/Agency/Pages/Cards/BusinessInformation.vue",
		"src_components_Agency_Pages_Cards_BusinessInformation_vue"
	],
	"./Agency/Pages/Cards/Contacts.vue": [
		"./src/components/Agency/Pages/Cards/Contacts.vue",
		"src_components_Agency_Pages_Cards_Contacts_vue"
	],
	"./Agency/Pages/Cards/CouponList.vue": [
		"./src/components/Agency/Pages/Cards/CouponList.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Pages_Cards_CouponList_vue"
	],
	"./Agency/Pages/Cards/CustomScripts.vue": [
		"./src/components/Agency/Pages/Cards/CustomScripts.vue",
		"src_components_Agency_Pages_Cards_CustomScripts_vue"
	],
	"./Agency/Pages/Cards/CustomURL.vue": [
		"./src/components/Agency/Pages/Cards/CustomURL.vue",
		"src_components_Agency_Pages_Cards_CustomURL_vue"
	],
	"./Agency/Pages/Cards/Files/Index.vue": [
		"./src/components/Agency/Pages/Cards/Files/Index.vue",
		"src_components_Agency_Pages_Cards_Files_Index_vue"
	],
	"./Agency/Pages/Cards/FormList.vue": [
		"./src/components/Agency/Pages/Cards/FormList.vue",
		"src_components_Agency_Pages_Cards_FormList_vue"
	],
	"./Agency/Pages/Cards/Invoices.vue": [
		"./src/components/Agency/Pages/Cards/Invoices.vue",
		"src_components_Agency_Pages_Cards_Invoices_vue"
	],
	"./Agency/Pages/Cards/LandingSettings.vue": [
		"./src/components/Agency/Pages/Cards/LandingSettings.vue",
		"src_store_modules_MCOptions_js",
		"src_components_Agency_Pages_Cards_LandingSettings_vue"
	],
	"./Agency/Pages/Cards/List.vue": [
		"./src/components/Agency/Pages/Cards/List.vue",
		"src_components_Agency_Pages_Cards_List_vue"
	],
	"./Agency/Pages/Cards/ListBreadcrumb.vue": [
		"./src/components/Agency/Pages/Cards/ListBreadcrumb.vue",
		"src_components_Agency_Pages_Cards_ListBreadcrumb_vue"
	],
	"./Agency/Pages/Cards/ListGridView.vue": [
		"./src/components/Agency/Pages/Cards/ListGridView.vue",
		"src_components_Agency_Pages_Cards_ListGridView_vue"
	],
	"./Agency/Pages/Cards/ListTopButtons.vue": [
		"./src/components/Agency/Pages/Cards/ListTopButtons.vue",
		"src_components_Agency_Pages_Cards_ListTopButtons_vue"
	],
	"./Agency/Pages/Cards/ListView.vue": [
		"./src/components/Agency/Pages/Cards/ListView.vue",
		"node_modules_vue-nestable_dist_index_umd_min_js",
		"src_components_Agency_Pages_Cards_ListView_vue"
	],
	"./Agency/Pages/Cards/ManageRedirect.vue": [
		"./src/components/Agency/Pages/Cards/ManageRedirect.vue",
		"src_components_Agency_Pages_Cards_ManageRedirect_vue"
	],
	"./Agency/Pages/Cards/MenuList.vue": [
		"./src/components/Agency/Pages/Cards/MenuList.vue",
		"src_components_Agency_Pages_Cards_MenuList_vue"
	],
	"./Agency/Pages/Cards/Payments.vue": [
		"./src/components/Agency/Pages/Cards/Payments.vue",
		"src_components_Agency_Pages_Cards_Payments_vue"
	],
	"./Agency/Pages/Cards/Podcast.vue": [
		"./src/components/Agency/Pages/Cards/Podcast.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Pages_Cards_Podcast_vue"
	],
	"./Agency/Pages/Cards/PrivacyAndTerms.vue": [
		"./src/components/Agency/Pages/Cards/PrivacyAndTerms.vue",
		"src_components_Agency_Pages_Cards_PrivacyAndTerms_vue"
	],
	"./Agency/Pages/Cards/ProductList.vue": [
		"./src/components/Agency/Pages/Cards/ProductList.vue",
		"src_components_Agency_Pages_Cards_ProductList_vue"
	],
	"./Agency/Pages/Cards/Products.vue": [
		"./src/components/Agency/Pages/Cards/Products.vue",
		"src_components_Agency_Pages_Cards_Products_vue"
	],
	"./Agency/Pages/Cards/SingleActions.vue": [
		"./src/components/Agency/Pages/Cards/SingleActions.vue",
		"src_components_Agency_Pages_Cards_SingleActions_vue",
		"src_permissions_js-_b76e0"
	],
	"./Agency/Pages/Cards/SingleCard.vue": [
		"./src/components/Agency/Pages/Cards/SingleCard.vue",
		"src_components_Agency_Pages_Cards_SingleCard_vue"
	],
	"./Agency/Pages/Cards/SingleListItem.vue": [
		"./src/components/Agency/Pages/Cards/SingleListItem.vue",
		"src_components_Agency_Pages_Cards_SingleListItem_vue"
	],
	"./Agency/Pages/Cards/Stats.vue": [
		"./src/components/Agency/Pages/Cards/Stats.vue",
		"src_components_Agency_Pages_Cards_Stats_vue"
	],
	"./Agency/Pages/Cards/Subscriptions.vue": [
		"./src/components/Agency/Pages/Cards/Subscriptions.vue",
		"src_components_Agency_Pages_Cards_Subscriptions_vue"
	],
	"./Agency/Pages/Cards/Users/DeleteModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/DeleteModal.vue",
		"src_components_Agency_Pages_Cards_Users_DeleteModal_vue"
	],
	"./Agency/Pages/Cards/Users/EditModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/EditModal.vue",
		"src_components_Agency_Pages_Cards_Users_EditModal_vue"
	],
	"./Agency/Pages/Cards/Users/EditPermissionsModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/EditPermissionsModal.vue",
		"src_components_Agency_Pages_Cards_Users_EditPermissionsModal_vue"
	],
	"./Agency/Pages/Cards/Users/FindModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/FindModal.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Pages_Cards_Users_FindModal_vue"
	],
	"./Agency/Pages/Cards/Users/Index.vue": [
		"./src/components/Agency/Pages/Cards/Users/Index.vue",
		"src_components_Agency_Pages_Cards_Users_Index_vue"
	],
	"./Agency/Pages/Cards/Users/NewModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/NewModal.vue",
		"src_components_Agency_Pages_Cards_Users_NewModal_vue"
	],
	"./Agency/Pages/Cards/Users/PermissionsModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/PermissionsModal.vue",
		"src_components_Agency_Pages_Cards_Users_PermissionsModal_vue"
	],
	"./Agency/Pages/Cards/Users/UnassignModal.vue": [
		"./src/components/Agency/Pages/Cards/Users/UnassignModal.vue",
		"src_components_Agency_Pages_Cards_Users_UnassignModal_vue"
	],
	"./Agency/Pages/Cards/Users/UserList.vue": [
		"./src/components/Agency/Pages/Cards/Users/UserList.vue",
		"src_components_Agency_Pages_Cards_Users_UserList_vue"
	],
	"./Agency/Pages/CreateFull.vue": [
		"./src/components/Agency/Pages/CreateFull.vue",
		"src_components_Agency_Pages_CreateFull_vue"
	],
	"./Agency/Pages/Design.vue": [
		"./src/components/Agency/Pages/Design.vue",
		"src_components_Agency_Pages_Design_vue"
	],
	"./Agency/Pages/DesignWrap.vue": [
		"./src/components/Agency/Pages/DesignWrap.vue",
		"src_components_Agency_Pages_DesignWrap_vue"
	],
	"./Agency/Pages/EditFull.vue": [
		"./src/components/Agency/Pages/EditFull.vue",
		"src_components_Agency_Pages_EditFull_vue"
	],
	"./Agency/Pages/Gateways/Create.vue": [
		"./src/components/Agency/Pages/Gateways/Create.vue",
		"src_components_Agency_Pages_Gateways_Create_vue"
	],
	"./Agency/Pages/Gateways/Forms/Stripe.vue": [
		"./src/components/Agency/Pages/Gateways/Forms/Stripe.vue",
		"src_components_Agency_Pages_Gateways_Forms_Stripe_vue"
	],
	"./Agency/Pages/Gateways/Index.vue": [
		"./src/components/Agency/Pages/Gateways/Index.vue",
		"src_components_Agency_Pages_Gateways_Index_vue"
	],
	"./Agency/Pages/IndexFounder.vue": [
		"./src/components/Agency/Pages/IndexFounder.vue",
		"src_components_Agency_Pages_IndexFounder_vue"
	],
	"./Agency/Pages/Sections/AboutSection.vue": [
		"./src/components/Agency/Pages/Sections/AboutSection.vue",
		"src_components_Agency_Pages_Sections_AboutSection_vue"
	],
	"./Agency/Pages/Sections/BannerSection.vue": [
		"./src/components/Agency/Pages/Sections/BannerSection.vue",
		"src_components_Agency_Pages_Sections_BannerSection_vue"
	],
	"./Agency/Pages/Sections/ServiceSection.vue": [
		"./src/components/Agency/Pages/Sections/ServiceSection.vue",
		"src_components_Agency_Pages_Sections_ServiceSection_vue"
	],
	"./Agency/Pages/Sections/TrialSection.vue": [
		"./src/components/Agency/Pages/Sections/TrialSection.vue",
		"src_components_Agency_Pages_Sections_TrialSection_vue"
	],
	"./Agency/Pages/Share.vue": [
		"./src/components/Agency/Pages/Share.vue",
		"src_components_Agency_Pages_Share_vue"
	],
	"./Agency/Pages/TypeStep.vue": [
		"./src/components/Agency/Pages/TypeStep.vue",
		"src_components_Agency_Pages_TypeStep_vue"
	],
	"./Agency/Podcast/Edit.vue": [
		"./src/components/Agency/Podcast/Edit.vue",
		"src_components_Agency_Podcast_Edit_vue"
	],
	"./Agency/Podcast/Form.vue": [
		"./src/components/Agency/Podcast/Form.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Podcast_Form_vue"
	],
	"./Agency/Websites/AgentAiPageDesign.vue": [
		"./src/components/Agency/Websites/AgentAiPageDesign.vue",
		"src_permissions_js-src_components_Agency_Websites_Styles_MagellanChiropracticDesign_scss",
		"src_components_Agency_Websites_AgentAiPageDesign_vue"
	],
	"./Agency/Websites/BuildStepFull.vue": [
		"./src/components/Agency/Websites/BuildStepFull.vue",
		"src_components_Agency_Websites_Styles_DesignBox_scss-src_components_Agency_Websites_Styles_Pr-7b908d",
		"src_components_Agency_Websites_BuildStepFull_vue"
	],
	"./Agency/Websites/CreateFull.vue": [
		"./src/components/Agency/Websites/CreateFull.vue",
		"src_store_modules_MCOptions_js",
		"src_components_Agency_Websites_CreateFull_vue"
	],
	"./Agency/Websites/Design.vue": [
		"./src/components/Agency/Websites/Design.vue",
		"src_components_Agency_Websites_Design_vue"
	],
	"./Agency/Websites/EditFull.vue": [
		"./src/components/Agency/Websites/EditFull.vue",
		"src_store_modules_MCOptions_js",
		"src_components_Agency_Websites_EditFull_vue"
	],
	"./Agency/Websites/FormBuilder.vue": [
		"./src/components/Agency/Websites/FormBuilder.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Agency_Websites_FormBuilder_vue"
	],
	"./Agency/Websites/FormCreate.vue": [
		"./src/components/Agency/Websites/FormCreate.vue",
		"src_components_Agency_Websites_FormCreate_vue"
	],
	"./Agency/Websites/FormEdit.vue": [
		"./src/components/Agency/Websites/FormEdit.vue",
		"src_components_Agency_Websites_FormEdit_vue"
	],
	"./Agency/Websites/FormIntegrations.vue": [
		"./src/components/Agency/Websites/FormIntegrations.vue",
		"src_components_Agency_Websites_FormIntegrations_vue"
	],
	"./Agency/Websites/FormRender.vue": [
		"./src/components/Agency/Websites/FormRender.vue",
		"src_components_Agency_Websites_FormRender_vue"
	],
	"./Agency/Websites/FormRender2.vue": [
		"./src/components/Agency/Websites/FormRender2.vue",
		"src_components_Agency_Websites_FormRender2_vue"
	],
	"./Agency/Websites/Index.vue": [
		"./src/components/Agency/Websites/Index.vue",
		"src_components_Agency_Websites_Index_vue"
	],
	"./Agency/Websites/Integrations/ActiveCampaign.vue": [
		"./src/components/Agency/Websites/Integrations/ActiveCampaign.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_ActiveCampaign_vue"
	],
	"./Agency/Websites/Integrations/Aweber.vue": [
		"./src/components/Agency/Websites/Integrations/Aweber.vue",
		"src_components_Agency_Websites_Integrations_Aweber_vue"
	],
	"./Agency/Websites/Integrations/ConvertKit.vue": [
		"./src/components/Agency/Websites/Integrations/ConvertKit.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_ConvertKit_vue"
	],
	"./Agency/Websites/Integrations/CustomerEngine.vue": [
		"./src/components/Agency/Websites/Integrations/CustomerEngine.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_CustomerEngine_vue"
	],
	"./Agency/Websites/Integrations/GHL.vue": [
		"./src/components/Agency/Websites/Integrations/GHL.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_GHL_vue"
	],
	"./Agency/Websites/Integrations/GetResponse.vue": [
		"./src/components/Agency/Websites/Integrations/GetResponse.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_GetResponse_vue"
	],
	"./Agency/Websites/Integrations/GoToWebinar.vue": [
		"./src/components/Agency/Websites/Integrations/GoToWebinar.vue",
		"src_components_Agency_Websites_Integrations_GoToWebinar_vue"
	],
	"./Agency/Websites/Integrations/Keap.vue": [
		"./src/components/Agency/Websites/Integrations/Keap.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Integrations_Keap_vue"
	],
	"./Agency/Websites/Integrations/Mailchimp.vue": [
		"./src/components/Agency/Websites/Integrations/Mailchimp.vue",
		"src_components_Agency_Websites_Integrations_Mailchimp_vue"
	],
	"./Agency/Websites/MagellanChiropracticDesign.vue": [
		"./src/components/Agency/Websites/MagellanChiropracticDesign.vue",
		"src_permissions_js-src_components_Agency_Websites_Styles_MagellanChiropracticDesign_scss",
		"src_components_Agency_Websites_MagellanChiropracticDesign_vue"
	],
	"./Agency/Websites/MenuBuilder2.vue": [
		"./src/components/Agency/Websites/MenuBuilder2.vue",
		"node_modules_vue-nestable_dist_index_umd_min_js",
		"src_components_Agency_Websites_MenuBuilder2_vue"
	],
	"./Agency/Websites/MenuCreate.vue": [
		"./src/components/Agency/Websites/MenuCreate.vue",
		"src_components_Agency_Websites_MenuCreate_vue"
	],
	"./Agency/Websites/MenuEdit.vue": [
		"./src/components/Agency/Websites/MenuEdit.vue",
		"src_components_Agency_Websites_MenuEdit_vue"
	],
	"./Agency/Websites/MenuRender.vue": [
		"./src/components/Agency/Websites/MenuRender.vue",
		"src_components_Agency_Websites_MenuRender_vue"
	],
	"./Agency/Websites/NavigationRender.vue": [
		"./src/components/Agency/Websites/NavigationRender.vue",
		"src_components_Agency_Websites_NavigationRender_vue"
	],
	"./Agency/Websites/RedirectCreate.vue": [
		"./src/components/Agency/Websites/RedirectCreate.vue",
		"src_components_Agency_Websites_RedirectCreate_vue"
	],
	"./Agency/Websites/RedirectEdit.vue": [
		"./src/components/Agency/Websites/RedirectEdit.vue",
		"src_components_Agency_Websites_RedirectEdit_vue"
	],
	"./Agency/Websites/RedirectList.vue": [
		"./src/components/Agency/Websites/RedirectList.vue",
		"src_components_Agency_Websites_RedirectList_vue"
	],
	"./Agency/Websites/Sections/AboutSection.vue": [
		"./src/components/Agency/Websites/Sections/AboutSection.vue",
		"src_components_Agency_Websites_Sections_AboutSection_vue"
	],
	"./Agency/Websites/Sections/ArticleSection.vue": [
		"./src/components/Agency/Websites/Sections/ArticleSection.vue",
		"src_components_Agency_Websites_Sections_ArticleSection_vue"
	],
	"./Agency/Websites/Sections/BannerSection.vue": [
		"./src/components/Agency/Websites/Sections/BannerSection.vue",
		"src_components_Agency_Websites_Sections_BannerSection_vue"
	],
	"./Agency/Websites/Sections/ContactSection.vue": [
		"./src/components/Agency/Websites/Sections/ContactSection.vue",
		"src_components_Agency_Websites_Sections_ContactSection_vue"
	],
	"./Agency/Websites/Sections/FooterSection.vue": [
		"./src/components/Agency/Websites/Sections/FooterSection.vue",
		"src_components_Agency_Websites_Sections_FooterSection_vue"
	],
	"./Agency/Websites/Sections/HeaderSection.vue": [
		"./src/components/Agency/Websites/Sections/HeaderSection.vue",
		"src_components_Agency_Websites_Sections_HeaderSection_vue"
	],
	"./Agency/Websites/Sections/ServiceSection.vue": [
		"./src/components/Agency/Websites/Sections/ServiceSection.vue",
		"src_components_Agency_Websites_Sections_ServiceSection_vue"
	],
	"./Agency/Websites/Sections/StylingSection.vue": [
		"./src/components/Agency/Websites/Sections/StylingSection.vue",
		"src_components_Agency_Websites_Sections_StylingSection_vue"
	],
	"./Agency/Websites/Settings.vue": [
		"./src/components/Agency/Websites/Settings.vue",
		"src_components_Agency_Websites_Settings_vue"
	],
	"./Agency/Websites/Share.vue": [
		"./src/components/Agency/Websites/Share.vue",
		"src_components_Agency_Websites_Share_vue"
	],
	"./Agency/Websites/TemplateStep.vue": [
		"./src/components/Agency/Websites/TemplateStep.vue",
		"src_components_Agency_Websites_TemplateStep_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/Banner.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/Banner.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BannerFounder_scss",
		"src_components_Agency_Websites_Templates_DigitalMarketing_Banner_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/BlogShow.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/BlogShow.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BlogContent_scss",
		"src_components_Agency_Websites_Templates_DigitalMarketing_BlogShow_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/Contact.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/Contact.vue",
		"src_components_Agency_Websites_Templates_DigitalMarketing_Contact_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/DigitalMarketing.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/DigitalMarketing.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_ServicesFounder_scss-src-9caeab",
		"src_components_Agency_Websites_Templates_DigitalMarketing_DigitalMarketing_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/Footer.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/Footer.vue",
		"src_components_Agency_Websites_Templates_DigitalMarketing_Footer_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/Header.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/Header.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_HeaderFounder_scss",
		"src_components_Agency_Websites_Templates_DigitalMarketing_Header_vue"
	],
	"./Agency/Websites/Templates/DigitalMarketing/Page.vue": [
		"./src/components/Agency/Websites/Templates/DigitalMarketing/Page.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BlogContent_scss",
		"src_components_Agency_Websites_Templates_DigitalMarketing_Page_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/About.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/About.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_About_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/AboutFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/AboutFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_AboutFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/AboutFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/AboutFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_AboutFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/AboutFull.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/AboutFull.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_AboutFull_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Articles.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Articles.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Articles_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Banner.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Banner.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Banner_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Banner2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Banner2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Banner2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BannerFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BannerFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BannerFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BannerForm.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BannerForm.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BannerForm_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BannerFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BannerFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BannerFounder_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BannerFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BannerTotal.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BannerTotal.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BannerTotal_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BlogShow.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BlogShow.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BlogContent_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BlogShow_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/BuildStepFullNew.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/BuildStepFullNew.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Index2_scss",
		"src_store_modules_MCOptions2_js",
		"src_components_Editors_Settings_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Index2_vue",
		"src_components_Editors_LeftDefaultModal_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_BuildStepFullNew_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Button.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Button.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Button_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Calltoaction.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Calltoaction.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Calltoaction_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Contact.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Contact.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Contact_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Faq.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Faq.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Faq_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Footer.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Footer.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Footer_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/FooterFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/FooterFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_FooterFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/FooterFounderLanding.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/FooterFounderLanding.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_FooterFounderLanding_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/FooterLanding.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/FooterLanding.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_FooterLanding_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Header.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Header.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Header_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Header_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/HeaderLanding.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/HeaderLanding.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Header_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_HeaderLanding_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Hours.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Hours.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Hours_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/HtmlEditor.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/HtmlEditor.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_HtmlEditor_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Index2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Index2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Index2_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Index2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Index2BlockPreview.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Index2BlockPreview.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Index2_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Index2BlockPreview_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Location.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Location.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Location_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/LocationMap.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/LocationMap.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_LocationMap_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Media.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Media.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Media_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Menu.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Menu.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Header_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Menu_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/MenuFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/MenuFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_HeaderFounder_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_MenuFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/MenuFounderLanding.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/MenuFounderLanding.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_HeaderFounder_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_MenuFounderLanding_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/MenuLanding.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/MenuLanding.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_Header_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_MenuLanding_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Page.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Page.vue",
		"src_store_modules_MCOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_BlogContent_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Page_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Paragraph.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Paragraph.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Paragraph_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/PhotoGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/PhotoGallery.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_PhotoGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Podcast.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Podcast.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Podcast_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFeatureSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFeatureSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_AboutFeatureSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFounderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFounderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_AboutFounderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFullSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/AboutFullSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_AboutFullSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/AboutSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/AboutSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_AboutSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ArticlesSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ArticlesSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ArticlesSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/Banner2Section.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/Banner2Section.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_Banner2Section_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFeatureSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFeatureSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_BannerFeatureSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFormSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFormSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_BannerFormSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFounderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/BannerFounderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_BannerFounderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/BannerSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/BannerSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_BannerSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/BannerTotalSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/BannerTotalSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_BannerTotalSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ButtonSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ButtonSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ButtonSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/CallToActionSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/CallToActionSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_CallToActionSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ContactSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ContactSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ContactSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/FaqSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/FaqSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_FaqSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/FooterFounderLandingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/FooterFounderLandingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_FooterFounderLandingSe-b76b30"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/FooterFounderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/FooterFounderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_FooterFounderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/FooterLandingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/FooterLandingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_FooterLandingSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/FooterSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/FooterSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_FooterSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/HeaderLandingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/HeaderLandingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_HeaderLandingSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/HeaderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/HeaderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_HeaderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/HoursSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/HoursSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_HoursSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/HtmlEditorSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/HtmlEditorSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_HtmlEditorSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/LocationMapSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/LocationMapSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_LocationMapSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/LocationSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/LocationSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_LocationSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/MediaSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/MediaSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_MediaSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/MenuFounderLandingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/MenuFounderLandingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_MenuFounderLandingSect-0140c3"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/MenuFounderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/MenuFounderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_MenuFounderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/MenuLandingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/MenuLandingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_MenuLandingSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/MenuSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/MenuSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_MenuSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ParagraphSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ParagraphSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ParagraphSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/PhotoGallerySection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/PhotoGallerySection.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_PhotoGallerySection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/PodcastSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/PodcastSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_PodcastSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesFeatureSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesFeatureSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ServicesFeatureSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesFounderSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesFounderSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ServicesFounderSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ServicesSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ServicesSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/SocialSharingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/SocialSharingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_SocialSharingSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/StaffsSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/StaffsSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_StaffsSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/StylingSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/StylingSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_StylingSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/TestimonialsSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/TestimonialsSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_TestimonialsSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/ThemeColors.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/ThemeColors.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_ThemeColors_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/TitleSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/TitleSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_TitleSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/TransitionSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/TransitionSection.vue",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_TransitionSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Sections/TrialFeatureSection.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Sections/TrialFeatureSection.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Sections_TrialFeatureSection_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Services.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Services.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Services_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/ServicesFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/ServicesFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_ServicesFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/ServicesFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/ServicesFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Styles_ServicesFounder_scss-src-9caeab",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_ServicesFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/SocialSharing.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/SocialSharing.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_SocialSharing_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Staffs.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Staffs.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Staffs_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Testimonials.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Testimonials.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Testimonials_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Title.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Title.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Title_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/Transition.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/Transition.vue",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_Transition_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic/TrialFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic/TrialFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic_TrialFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Articles.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Articles.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Articles2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Articles2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/BannerFounder.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/BannerFounder.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/BulletList.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/BulletList.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Button.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Button.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Button_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Checkbox.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Checkbox.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Contact.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Contact.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Contact2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Contact2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Countdown.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Countdown.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Coupon.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Coupon.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/CreditCard.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/CreditCard.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/DayTimer.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/DayTimer.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_Countdown_scss-_391e0"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Dropdown.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Dropdown.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Dropdown_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Faq.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Faq.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Faq2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Faq2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Form.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Form.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Form_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/Card.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/Card.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_Card_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/Coverflow.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/Coverflow.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_Coverflow_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/Creative.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/Creative.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_Creative_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/MasonryGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/MasonryGallery.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_MasonryGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/Slide.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/Slide.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_Slide_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Gallery/StandardGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Gallery/StandardGallery.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Gallery_StandardGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoToInfo.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoToInfo.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoToInfo_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Business.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Business.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_Business_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Carousel.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Carousel.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_Carousel_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Grid.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Grid.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_Grid_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/List.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/List.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_List_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Masonry.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/Masonry.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_Masonry_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/SingleReview.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/GoogleReview/SingleReview.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_SingleReview_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/HtmlEditor.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/HtmlEditor.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_HtmlEditor_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/IconCard.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/IconCard.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Input.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Input.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/LocationMap.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/LocationMap.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_LocationMap_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/MinuteTimer.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/MinuteTimer.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_Countdown_scss-_391e1"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Navigation.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Navigation.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NavigationFooter.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NavigationFooter.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeAudio.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeAudio.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeIcon.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeIcon.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIcon_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeIconFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeIconFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeImage.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeImage.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeImageFeature.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeImageFeature.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeImageFeature2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeImageFeature2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/NeVideo.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/NeVideo.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/OrderSelect.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/OrderSelect.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/OrderSummary.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/OrderSummary.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSummary_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Paragraph.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Paragraph.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Paragraph2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Paragraph2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PhotoGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PhotoGallery.vue",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Podcast.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Podcast.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Carousel.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Carousel.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_Carousel_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Grid.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Grid.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_Grid_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Info.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/Info.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_Info_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/SingleEpisode.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/PodcastGallery/SingleEpisode.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_SingleEpisode_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/QuickLink.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/QuickLink.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_QuickLink_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/Articles2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/Articles2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_Articles2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/ArticlesSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/ArticlesSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_ArticlesSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/BannerFounderSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/BannerFounderSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_BannerFounderSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/BulletListSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/BulletListSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_BulletListSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/ButtonSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/ButtonSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_ButtonSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/CheckboxSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/CheckboxSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_CheckboxSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/ColumnSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/ColumnSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_ColumnSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/Contact2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/Contact2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_Contact2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/ContactSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/ContactSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_ContactSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/CountdownSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/CountdownSettings.vue",
		"node_modules_vue-flatpickr-component_dist_vue-flatpickr_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_CountdownTheme_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_CountdownSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/CouponSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/CouponSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_CouponSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/CreditCardSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/CreditCardSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_CreditCardSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/DayTimerSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/DayTimerSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_CountdownTheme_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_DayTimerSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/DropdownSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/DropdownSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_DropdownSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/Faq2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/Faq2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_Faq2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/FaqSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/FaqSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_FaqSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/FormSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/FormSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_FormSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/GoToInfoSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/GoToInfoSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_GoToInfoSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/GoogleReviewSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/GoogleReviewSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_GoogleReviewSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/HtmlEditorSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/HtmlEditorSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_HtmlEditorSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/IconCardSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/IconCardSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_IconCardSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/InputSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/InputSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_InputSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/LocationMapSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/LocationMapSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_LocationMapSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/MinuteTimerSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/MinuteTimerSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_CountdownTheme_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_MinuteTimerSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NavigationFooterSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NavigationFooterSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NavigationFooterSetti-31f1f8"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NavigationSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NavigationSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NavigationSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeAudioSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeAudioSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeAudioSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeIconFeatureSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeIconFeatureSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeIconTheme_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeIconFeatureSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeIconSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeIconSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeIconTheme_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeIconSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageFeature2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageFeature2Settings.vue",
		"src_store_modules_SVGSkinOptions_js-src_components_Agency_Websites_Templates_MagellanChiropra-dfe76c",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeImageFeature2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageFeatureSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageFeatureSettings.vue",
		"src_store_modules_SVGSkinOptions_js-src_components_Agency_Websites_Templates_MagellanChiropra-dfe76c",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeImageFeatureSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeImageSettings.vue",
		"src_store_modules_SVGSkinOptions_js-src_components_Agency_Websites_Templates_MagellanChiropra-dfe76c",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeImageSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/NeVideoSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/NeVideoSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_NeVideoSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/OrderSelectSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/OrderSelectSettings.vue",
		"node_modules_vue-multiselect_dist_vue-multiselect_min_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_OrderSelectSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/OrderSummarySettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/OrderSummarySettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_OrderSummarySettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/Paragraph2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/Paragraph2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_Paragraph2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/ParagraphSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/ParagraphSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_ParagraphSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/PhotoGallerySettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/PhotoGallerySettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_PhotoGallerySettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/PodcastGallerySettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/PodcastGallerySettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_PodcastGallerySettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/PodcastSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/PodcastSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_PodcastSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/QuickLinkSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/QuickLinkSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_QuickLinkSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/RowSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/RowSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_RowSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionHeaderSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionHeaderSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SectionHeaderSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionMenuSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionMenuSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SectionMenuSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionPopupSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionPopupSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SectionPopupSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SectionSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SectionSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SocialLinkSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SocialLinkSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SocialLinkSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SocialSharingSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SocialSharingSettings.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SocialSharingSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/StripeLinkSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/StripeLinkSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_StripeLinkSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/SubHeadline2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/SubHeadline2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_SubHeadline2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/TextareaSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/TextareaSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_TextareaSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/TitleHeadline2Settings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/TitleHeadline2Settings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_TitleHeadline2Settings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/TitleHeadlineSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/TitleHeadlineSettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_TitleHeadlineSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/TransitionSettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/TransitionSettings.vue",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_TransitionSettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Settings/YoutubeGallerySettings.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Settings/YoutubeGallerySettings.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Settings_YoutubeGallerySettings_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/SocialLink.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/SocialLink.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialLink_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/SocialSharing.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/SocialSharing.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/StripeLink.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/StripeLink.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_StripeLink_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/SubHeadline2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/SubHeadline2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SubHeadline2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Textarea.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Textarea.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Textarea_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/TitleHeadline.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/TitleHeadline.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_TitleHeadline_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/TitleHeadline2.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/TitleHeadline2.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_TitleHeadline2_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/Transition.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/Transition.vue",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Transition_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Carousel.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Carousel.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_Carousel_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Grid.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Grid.vue",
		"node_modules_swiper_modules_index_mjs-node_modules_swiper_swiper_mjs",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_Grid_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Info.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/Info.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_Info_vue"
	],
	"./Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/SingleVideo.vue": [
		"./src/components/Agency/Websites/Templates/MagellanChiropractic2/YoutubeGallery/SingleVideo.vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_SingleVideo_vue"
	],
	"./Agency/Websites/WebhookList.vue": [
		"./src/components/Agency/Websites/WebhookList.vue",
		"src_components_Agency_Websites_WebhookList_vue",
		"src_permissions_js-_b76e1"
	],
	"./Common/ActionButton.vue": [
		"./src/components/Common/ActionButton.vue"
	],
	"./Common/AlignInput.vue": [
		"./src/components/Common/AlignInput.vue"
	],
	"./Common/BlockModal.vue": [
		"./src/components/Common/BlockModal.vue",
		"src_store_modules_MCOptions_js",
		"src_components_Common_BlockModal_vue"
	],
	"./Common/BoxEditor.vue": [
		"./src/components/Common/BoxEditor.vue",
		"src_components_Common_BoxEditor_vue"
	],
	"./Common/ButtonEditor.vue": [
		"./src/components/Common/ButtonEditor.vue",
		"src_components_Common_ButtonEditor_vue"
	],
	"./Common/ButtonRenderer.vue": [
		"./src/components/Common/ButtonRenderer.vue"
	],
	"./Common/ColorInput.vue": [
		"./src/components/Common/ColorInput.vue"
	],
	"./Common/ColorPickerModalNew.vue": [
		"./src/components/Common/ColorPickerModalNew.vue",
		"src_components_Common_ColorPickerModalNew_vue"
	],
	"./Common/CustomDraggable.vue": [
		"./src/components/Common/CustomDraggable.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"src_components_Common_CustomDraggable_vue"
	],
	"./Common/CustomDraggable2.vue": [
		"./src/components/Common/CustomDraggable2.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"src_components_Common_CustomDraggable2_vue"
	],
	"./Common/Editor.vue": [
		"./src/components/Common/Editor.vue"
	],
	"./Common/ElementsPicker.vue": [
		"./src/components/Common/ElementsPicker.vue"
	],
	"./Common/FontSelect.vue": [
		"./src/components/Common/FontSelect.vue"
	],
	"./Common/FullVideoWrapper.vue": [
		"./src/components/Common/FullVideoWrapper.vue",
		"src_components_Common_FullVideoWrapper_vue"
	],
	"./Common/IconPicker.vue": [
		"./src/components/Common/IconPicker.vue"
	],
	"./Common/ImageInput.vue": [
		"./src/components/Common/ImageInput.vue"
	],
	"./Common/ImageInput2.vue": [
		"./src/components/Common/ImageInput2.vue"
	],
	"./Common/LogoInput.vue": [
		"./src/components/Common/LogoInput.vue"
	],
	"./Common/LogoInput2.vue": [
		"./src/components/Common/LogoInput2.vue"
	],
	"./Common/ManagePermissions.vue": [
		"./src/components/Common/ManagePermissions.vue",
		"src_components_Common_ManagePermissions_vue"
	],
	"./Common/NumberInput.vue": [
		"./src/components/Common/NumberInput.vue"
	],
	"./Common/NumberInput2.vue": [
		"./src/components/Common/NumberInput2.vue"
	],
	"./Common/NumberPack.vue": [
		"./src/components/Common/NumberPack.vue"
	],
	"./Common/ParallaxView.vue": [
		"./src/components/Common/ParallaxView.vue",
		"src_components_Common_ParallaxView_vue"
	],
	"./Common/PhoneInput.vue": [
		"./src/components/Common/PhoneInput.vue"
	],
	"./Common/Profile.vue": [
		"./src/components/Common/Profile.vue",
		"src_components_Common_Profile_vue"
	],
	"./Common/ProfileUpload.vue": [
		"./src/components/Common/ProfileUpload.vue",
		"src_components_Common_ProfileUpload_vue"
	],
	"./Common/ShadowBox.vue": [
		"./src/components/Common/ShadowBox.vue",
		"src_components_Common_ShadowBox_vue"
	],
	"./Common/SocialButtonEditor.vue": [
		"./src/components/Common/SocialButtonEditor.vue",
		"node_modules_sortablejs_modular_sortable_esm_js",
		"node_modules_vuedraggable_dist_vuedraggable_umd_js",
		"src_components_Common_SocialButtonEditor_vue"
	],
	"./Common/TextEditor.vue": [
		"./src/components/Common/TextEditor.vue"
	],
	"./Common/TextEditor2.vue": [
		"./src/components/Common/TextEditor2.vue"
	],
	"./Common/TextInput.vue": [
		"./src/components/Common/TextInput.vue"
	],
	"./Common/UploadFile.vue": [
		"./src/components/Common/UploadFile.vue"
	],
	"./Common/UploadImage.vue": [
		"./src/components/Common/UploadImage.vue"
	],
	"./Common/UploadNonConvertImage.vue": [
		"./src/components/Common/UploadNonConvertImage.vue"
	],
	"./Common/VideoInput.vue": [
		"./src/components/Common/VideoInput.vue"
	],
	"./Common/VideoPopup.vue": [
		"./src/components/Common/VideoPopup.vue",
		"src_components_Common_VideoPopup_vue"
	],
	"./Common/ViewPermissions.vue": [
		"./src/components/Common/ViewPermissions.vue",
		"src_components_Common_ViewPermissions_vue"
	],
	"./Editors/AddBlock.vue": [
		"./src/components/Editors/AddBlock.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_AddBlock_vue"
	],
	"./Editors/AddElement.vue": [
		"./src/components/Editors/AddElement.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_AddElement_vue"
	],
	"./Editors/AddRow.vue": [
		"./src/components/Editors/AddRow.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_AddRow_vue"
	],
	"./Editors/AddSection.vue": [
		"./src/components/Editors/AddSection.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_AddSection_vue"
	],
	"./Editors/BlockPreviewModal.vue": [
		"./src/components/Editors/BlockPreviewModal.vue",
		"src_components_Editors_BlockPreviewModal_vue"
	],
	"./Editors/ButtonRenderer2.vue": [
		"./src/components/Editors/ButtonRenderer2.vue"
	],
	"./Editors/ChildRowContainer.vue": [
		"./src/components/Editors/ChildRowContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/ColumnContainer.vue": [
		"./src/components/Editors/ColumnContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/CustomCSS.vue": [
		"./src/components/Editors/CustomCSS.vue",
		"src_components_Editors_CustomCSS_vue"
	],
	"./Editors/ElementContainer.vue": [
		"./src/components/Editors/ElementContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Editors_ElementContainer_vue"
	],
	"./Editors/GlobalSettings.vue": [
		"./src/components/Editors/GlobalSettings.vue",
		"src_components_Editors_GlobalSettings_vue"
	],
	"./Editors/LeftDefaultModal.vue": [
		"./src/components/Editors/LeftDefaultModal.vue",
		"src_components_Editors_LeftDefaultModal_vue"
	],
	"./Editors/ListColumnView.vue": [
		"./src/components/Editors/ListColumnView.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_ListColumnView_vue"
	],
	"./Editors/ListElementView.vue": [
		"./src/components/Editors/ListElementView.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_ListElementView_vue"
	],
	"./Editors/ListRowView.vue": [
		"./src/components/Editors/ListRowView.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_ListColumnView_vue",
		"src_components_Editors_ListRowView_vue"
	],
	"./Editors/ListSectionView.vue": [
		"./src/components/Editors/ListSectionView.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_components_Editors_ListColumnView_vue",
		"src_components_Editors_ListSectionView_vue"
	],
	"./Editors/NewColumnContainer.vue": [
		"./src/components/Editors/NewColumnContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/NewSingleColumnContainer.vue": [
		"./src/components/Editors/NewSingleColumnContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/NewSingleRowContainer.vue": [
		"./src/components/Editors/NewSingleRowContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/Popup.vue": [
		"./src/components/Editors/Popup.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue",
		"src_components_Editors_Popup_vue"
	],
	"./Editors/RightFloatingModal.vue": [
		"./src/components/Editors/RightFloatingModal.vue",
		"src_components_Editors_RightFloatingModal_vue"
	],
	"./Editors/RowContainer.vue": [
		"./src/components/Editors/RowContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/SaveBlock.vue": [
		"./src/components/Editors/SaveBlock.vue",
		"src_components_Editors_SaveBlock_vue"
	],
	"./Editors/SectionContainer.vue": [
		"./src/components/Editors/SectionContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue",
		"src_components_Editors_SectionContainer_vue"
	],
	"./Editors/Settings.vue": [
		"./src/components/Editors/Settings.vue",
		"src_components_Editors_Settings_vue"
	],
	"./Editors/SingleColumnContainer.vue": [
		"./src/components/Editors/SingleColumnContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/SingleElementContainer.vue": [
		"./src/components/Editors/SingleElementContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue"
	],
	"./Editors/SinglePopupSectionContainer.vue": [
		"./src/components/Editors/SinglePopupSectionContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue",
		"src_components_Editors_SinglePopupSectionContainer_vue"
	],
	"./Editors/SingleRowContainer.vue": [
		"./src/components/Editors/SingleRowContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Editors/SingleSectionContainer.vue": [
		"./src/components/Editors/SingleSectionContainer.vue",
		"node_modules_vue-smooth-dnd_dist_vue-smooth-dnd_esm_js",
		"src_store_modules_SVGOptions_js",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Styles_NeImageThemeFE_scss",
		"src_design_swiper11_scss",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_IconCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PodcastGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_YoutubeGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_GoogleReview_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeIconFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_PhotoGallery_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImageFeature_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Podcast_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Navigation_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Faq2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Countdown_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_SocialSharing_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Articles_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeImage_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_OrderSelect_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_DayTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_MinuteTimer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BulletList_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Input_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Paragraph2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NavigationFooter_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Contact2_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Checkbox_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_CreditCard_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_Coupon_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeVideo_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_NeAudio_vue",
		"src_components_Editors_SingleElementContainer_vue",
		"src_components_Agency_Websites_Templates_MagellanChiropractic2_BannerFounder_vue",
		"src_components_Editors_ElementContainer_vue",
		"src_components_Editors_SingleColumnContainer_vue"
	],
	"./Layouts/Full.vue": [
		"./src/components/Layouts/Full.vue"
	],
	"./Pages/NotFound.vue": [
		"./src/components/Pages/NotFound.vue",
		"src_components_Pages_NotFound_vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/components lazy recursive ^\\.\\/.*\\.vue$";
module.exports = webpackAsyncContext;